import Component from 'antd/es/message';
import 'antd/lib/message/style';
export default Component;
